
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes-terms",
      function () {
        return require("private-next-pages/notes-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes-terms"])
      });
    }
  